const PathItem = require("library/models/path-item").default

class PathAdminStore extends require("lib/static-shim").default(
  require("lib/core/store/backbone-store").default
) {
  static initClass() {
    this.prototype.defaults = {
      selection: null, // the topic/group/step being created/updated
      editing_selection: false, // is selection for editing
      archiving_selection: false // is selection for archiving
    }

    // These triggers are fired by withPathItemMutations
    this.prototype.storeTriggers = {
      "path:item:created"(item) {
        return item
      },
      "path:item:updated"(item) {
        return item
      },
      "path:item:archived"(item) {
        return item
      }
    }

    this.prototype.storeTriggerHandlers = {
      path: {
        "change:expanded_groups"() {
          // When the path's expanded groups change, make sure tha either there is no currrent
          // selection or that the selection is included in the expanded groups, otherwise we
          // need to unselect the path item to avoid some odd Drag/Drop error occurring when
          // the PathStepEditor mounts with the isEditing flag set to true.
          const { expanded_groups } = App.getStore("path").getState()
          const { selection } = this.getState()
          // Ensure workable array.
          const sourceIds = [].concat(expanded_groups).filter(Boolean)
          if (selection) {
            const match = sourceIds.find(
              (sourceId) => sourceId === selection.parent_source_id
            )
            if (!match) {
              this.action.unSelectPathItem()
            }
          }
        }
      }
    }

    this.prototype.actions = {
      selectPathItem(data) {
        if (_.isFunction(data.toJSON != null)) {
          throw new Error(
            "Only raw JS data can be passed to selectPathItem. You passed a model."
          )
        }
        return this._mutate({
          selection: new PathItem(data)
        })
      },

      selectNewPathItem(data) {
        const itemData = _.defaults({}, data, {
          path_id: window.App.getStore("path").get("path").id
        })
        return this._mutate({
          selection: new PathItem(itemData),
          editing_selection: false,
          archiving_selection: false
        })
      },

      selectPathItemForEditing(data) {
        this.action.selectPathItem(data)
        return this._mutate({
          editing_selection: true,
          archiving_selection: false
        })
      },

      selectPathItemForArchiving(data) {
        // prevent selecting item for archiving if currently archiving
        if (this.get("is_saving_selection") && this.get("archiving_selection"))
          return

        this.action.selectPathItem(data)
        return this._mutate({
          archiving_selection: true,
          editing_selection: false
        })
      },

      unSelectPathItem() {
        return this._mutate({
          selection: null,
          editing_selection: false,
          archiving_selection: false
        })
      }
    }
  }
}
PathAdminStore.initClass()

export default window.App.stores.registerStore("pathAdmin", PathAdminStore)
